import React, { FC } from 'react';
import { Form, Icon, Upload } from 'antd';
import { RcFile, UploadFile } from 'antd/lib/upload/interface';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { ATTACHMENT_ACCEPT } from '../../../helpers/uploadFileTypes';

const { Dragger } = Upload;

interface Props {
  addAppointmentAttachment: (file: File, fileList: File[]) => void;
  form: WrappedFormUtils;
  removeAppointmentAttachment: (file: UploadFile) => boolean;
}

export const UploadAppointmentAttachment: FC<Props> = ({
  addAppointmentAttachment,
  form,
  removeAppointmentAttachment,
}): JSX.Element => {
  const { getFieldDecorator } = form;

  const beforeUpload = (file: RcFile, fileList: RcFile[]): boolean => {
    addAppointmentAttachment(file, fileList);
    return false;
  };

  const onRemove = (file: UploadFile): boolean => {
    return removeAppointmentAttachment(file);
  };

  return (
    <Form.Item>
      {getFieldDecorator('appointmentAttachments', { rules: [{ required: false }] })(
        <Dragger multiple accept={ATTACHMENT_ACCEPT} beforeUpload={beforeUpload} onRemove={onRemove}>
          <p className="ant-upload-drag-icon">
            <Icon type="inbox" />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload.</p>
          <p className="ant-upload-hint">Attach any required files to your appointment here.</p>
        </Dragger>
      )}
    </Form.Item>
  );
};
